// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"ea8f61e4","828":"27645fb7"}[chunkId] + ".chunk.js";
};